export const FLOOR_CONFIG = {
  gridSize: 30,
  tileSize: 0.38,
  tileHeight: 0.09,
  gap: 0.025,
  explosionRadius: 4.7,
  lowerGroundY: -1.15,
  maxPixelRatio: 1.75,
} as const;

export const BREAK_SEQUENCE = {
  transitionDurationMs: 1900,
  freezePhysicsAfterMs: 5200,
  explosionDelayMs: 430,
  restoreDurationSeconds: 1.6,
  restoreCompletionMs: 1750,
} as const;
